"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FolderFill = {
  name: 'folder',
  theme: 'fill',
  nameWithTheme: 'folder-fill',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    class: 'icon',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M880 298.4H521L403.7 186.2c-1.5-1.4-3.5-2.2-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z'
    },
    children: []
  }]
};
exports.default = FolderFill;